// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c25c32d","453":"45a1c75a","455":"48a81b59"}[chunkId] + ".chunk.js";
};